// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__vZWMo","actionsCol":"EnrolledClinics_actionsCol__Ah108"};